module.exports = __webpack_public_path__ + "static/media/thumb2.ca452d4e.png";